import React from "react";
import { PdfIcon } from "../../asset/icons/Icon";
import { motion } from "framer-motion";
import moment from "moment";
import { MdOutlineDelete } from "react-icons/md";
import {
  confirmToast,
  IconsImgObj,
  images,
  notifyDanger,
  notifySuccess,
} from "../../actions/customFn";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../api/axios";

const ResourceList = ({ resource, setIsUpdate }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const deleteFile = (file) => {
    const url = `/batch/resource-delete-file`;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
      },
    };
    const data = {
      id: id,
      file,
    };
    axios
      .put(url, data, config)
      .then((res) => {
        const { message } = res.data;
        setIsUpdate((p) => !p);
        notifySuccess(message);
      })
      .catch((err) => {
        notifyDanger(err?.response?.data?.message || "Some Error Occured!");
      });
  };

const thStyle = {
  padding: "12px",
  fontSize: "14px",
  fontWeight: "600",
  borderBottom: "1px solid #10b981",
};

const tdStyle = {
  padding: "12px",
  fontSize: "14px",
};

return (
  <div>
    <motion.div
      style={{
        background: "#171717",
        borderRadius: "10px",
        padding: "15px",
        boxShadow: "0 2px 8px #10b981",
        overflowX: "auto",
        color: "white",
      }}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "left",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#292929" }}>
            <th style={thStyle}>File Name</th>
            <th style={thStyle}>Uploaded At</th>
            <th style={thStyle}>File Type</th>
            <th style={thStyle}></th>
          </tr>
        </thead>

        <tbody>
          {resource?.files?.length > 0 &&
            resource?.files.map((data, i) => {
              return (
                <tr
                  key={i}
                  style={{
                    borderBottom: "1px solid #10b981",
                  }}
                >
                  <td style={tdStyle}>
                    <div
                      onClick={() => window.open(data.url)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        alt=""
                        src={
                          IconsImgObj[data.file_type] ||
                          images["fileicon.png"]
                        }
                        style={{
                          width: "28px",
                          height: "28px",
                          objectFit: "contain",
                        }}
                      />

                      <span>
                        {data.file_name.length > 20
                          ? data.file_name.slice(0, 20) +
                            "..." +
                            data.file_type
                          : data.file_name}
                      </span>
                    </div>
                  </td>

                  <td style={tdStyle}>
                    {moment(data.date).format("DD MM YYYY LT")}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textTransform: "uppercase",
                      fontWeight: "500",
                    }}
                  >
                    {data.file_type}
                  </td>

                  <td style={tdStyle}>
                    <MdOutlineDelete
                      onClick={() => {
                        confirmToast(
                          "Are you want to delete file?",
                          () => {
                            deleteFile(data);
                          }
                        );
                      }}
                      fill="#10b981"
                      style={{
                        transform: "scale(1.5)",
                        marginRight: "12px",
                        cursor: "pointer",
                      }}
                    />
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </motion.div>
  </div>
);

};

export default ResourceList;
